import React from 'react'
import WorkListViewStoreProviderSpp from 'context/WorkListViewStore/SPP/WorkListViewStore.spp'
import PageContainerDesktop from '../../../../components/PageContainer/layout/PageContainer.desktop'
import { SppWorkListView } from './components/SppWorkListView/SppWorkListView'

const WorkListViewSppDesktop = props => (
  <WorkListViewStoreProviderSpp {...props}>
    <PageContainerDesktop>
      <SppWorkListView />
    </PageContainerDesktop>
  </WorkListViewStoreProviderSpp>
)

export default WorkListViewSppDesktop
